import {modal} from 'mc/lib';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router';
import {Route, Switch} from 'react-router-dom';
import './Layout.scss';
import PlatbaPage from './pages/PlatbaPage';
import PredpisyAPlatbyPage from './pages/PredpisyAPlatbyPage';
import ZadostPage from './pages/ZadostPage';
import * as authActions from "mc/lib/actions/authActions";
import LogovaniApiPage from "./pages/LogovaniApiPage";
import RegistracePage from "./pages/RegistracePage";
import RegistraceUspechPage from "./pages/RegistraceUspechPage";

class Layout extends Component {

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(authActions.fetchAuthInfoIfNeeded());
    }

    render() {
        return (
            <div key="layout" className="layout-container">
                <modal.ModalDialog key="modal-dialog"/>
                <Switch key="switch">
                    {/* Při přidání nové route povolte také URL pattern na AppIndexController. */}
                    <Route path="/zadost/:id" component={ZadostPage}/>
                    <Route path="/platba/:id" component={PlatbaPage}/>
                    <Route path="/predpisy-a-platby/platby/" component={PredpisyAPlatbyPage}/>
                    <Route path="/predpisy-a-platby/zadosti/" component={PredpisyAPlatbyPage}/>
                    <Route path="/predpisy-a-platby/" render={() => <Redirect to="/predpisy-a-platby/zadosti/"/>}/>
                    <Route path="/logovani-api/" component={LogovaniApiPage}/>
                    <Route path="/registrace/success" component={RegistraceUspechPage}/>
                    <Route path="/registrace" component={RegistracePage}/>
                    <Route component={() => <div>404</div>}/>
                </Switch>
            </div>
        );
    }

}

export default withRouter(connect()(Layout));
